import { createContext, useContext } from "react";

const noop = () => {};

/**
 * Lets page-specific drawer rows (the contextual section registered via
 * `useMobileDrawerOverride`) force-close the whole nav drawer stack.
 *
 * Rows that open a nested child drawer (Sorting, Visibility, ...) need this:
 * a plain `Drawer.Close` inside the child only dismisses the child and leaves
 * the parent nav drawer open behind it.
 */
export const DrawerCloseAllContext = createContext<() => void>(noop);
DrawerCloseAllContext.displayName = "DrawerCloseAllContext";

export const useDrawerCloseAll = () => useContext(DrawerCloseAllContext);
